// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-section {
    margin-top: 20px  !important;
    padding: 16px 24px  !important;
    background-color: #e7e4e4ea  !important;
    border-radius: 12px  !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08)  !important;
  }
  
  .radio-label {
    font-size: 18px  !important;
    font-weight: 600  !important;
    color: #333   !important;
    margin-bottom: 12px  !important;
  }
  
  .radio-group {
    display: flex  !important;
    flex-wrap: wrap  !important;
    gap: 24px  !important;
  }
  
  .radio-option {
    margin-right: 16px  !important;
  }
  
  .radio-option .MuiFormControlLabel-label {
    font-size: 16px  !important;
    color: #444  !important;
  }
  .button-container {
    display: flex  !important;
    gap: 12px  !important;
    margin-top: 20px  !important;
    justify-content: end  !important;
  }
  .add-alias-btn {
    background-color: #fe602f  !important;
    color: white  !important;
    text-transform: none  !important;
  }
  
  .add-alias-btn:hover {
    background-color: #e25529  !important;
  }
  
  /* Add Section button - outlined style */
  .add-section-btn {
    border: 1px solid #fe602f  !important;
    color: #fe602f  !important;
    text-transform: none  !important;
  }
  
  .add-section-btn:hover {
    background-color: #fff2ec  !important;
    border-color: #e25529  !important;
    color: #e25529  !important;
  }


  .dialog-box-container-modern {
    padding: 32px !important;
    background: linear-gradient(to bottom right, #ffffff, #f9f9f9) !important;
    border-radius: 20px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1) !important;
  }
  
  .dialog-title-modern {
    font-size: 24px !important;
    font-weight: 700 !important;
    color: #0070E9 !important;
    padding: 24px 32px 0 !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .dialog-close-icon {
    color: #888 !important;
    transition: transform 0.3s ease, color 0.3s ease !important;
  }
  .dialog-close-icon:hover {
    color: #d32f2f !important;
    transform: rotate(90deg) !important;
  }
  
  .input-label-modern {
    font-size: 15px !important;
    font-weight: 600 !important;
    margin: 20px 0 6px !important;
    color: #3a3a3a !important;
  }
  
  .text-field-modern {
    width: 100% !important;
    margin-bottom: 20px !important;
    background-color: #f1f3f4 !important;
    border-radius: 10px !important;
    border: 1px solid #ccc !important;
    transition: box-shadow 0.3s ease !important;
  }
  .text-field-modern:hover {
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1) !important;
  }
  
  .add-btn-modern {
    background-color: #FE602F !important;
    color: #FFFFFF !important;
    font-weight: 600 !important;
    padding: 10px 26px !important;
    border-radius: 12px !important;
    text-transform: capitalize !important;
    margin-top: 12px !important;
    box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3) !important;
  }
  .add-btn-modern:hover {
    background-color: #fc521e !important;
  }
  
  .section-divider-modern {
    margin: 40px 0 24px !important;
    border: none !important;
    border-top: 1px solid #ddd !important;
  }
  
  .section-note-modern {
    font-size: 14px !important;
    color: #555 !important;
    margin-bottom: 8px !important;
    font-style: italic !important;
  }
  
  .radio-label-modern {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #333 !important;
    margin-bottom: 12px !important;
  }
  
  /* body {
    font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif !important;
  } */

  .alias-edit-header {
    background-color: #2d3e50 !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 18px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 16px 24px !important;
  }
  
  .alias-edit-close {
    color: #ffffff !important;
    transition: transform 0.2s ease-in-out !important;
  }
  .alias-edit-close:hover {
    transform: rotate(90deg) !important;
  }
  
  .alias-edit-body {
    background-color: #f4f6f8 !important;
    padding: 32px 24px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 20px !important;
    border-left: 5px solid #2d3e50 !important;
  }
  
  .alias-edit-label {
    font-size: 14px !important;
    color: #333333 !important;
    font-weight: 500 !important;
  }
  
  .alias-edit-input {
    background-color: #ffffff !important;
    border-radius: 6px !important;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  }
  
  .alias-edit-submit {
    background-color: #2d3e50 !important;
    color: #ffffff !important;
    text-transform: none !important;
    font-weight: 500 !important;
    border-radius: 6px !important;
    padding: 8px 20px !important;
    align-self: flex-start !important;
    transition: background-color 0.3s ease !important;
  }
  
  .alias-edit-submit:hover {
    background-color: #1c2938 !important;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/views/panel/vraShifts/QualityDashboard/QualitySettings.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,uCAAuC;IACvC,+BAA+B;IAC/B,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,4BAA4B;IAC5B,gCAAgC;EAClC;EACA;IACE,qCAAqC;IACrC,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;EACvC;;EAEA,wCAAwC;EACxC;IACE,qCAAqC;IACrC,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;IACE,qCAAqC;IACrC,iCAAiC;IACjC,0BAA0B;EAC5B;;;EAGA;IACE,wBAAwB;IACxB,yEAAyE;IACzE,8BAA8B;IAC9B,qDAAqD;EACvD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,+BAA+B;IAC/B,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,2DAA2D;EAC7D;EACA;IACE,yBAAyB;IACzB,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,oCAAoC;IACpC,8BAA8B;IAC9B,iCAAiC;IACjC,2CAA2C;EAC7C;EACA;IACE,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,qCAAqC;IACrC,2BAA2B;IAC3B,yDAAyD;EAC3D;EACA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;;KAEG;;EAEH;IACE,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,iDAAiD;EACnD;EACA;IACE,mCAAmC;EACrC;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,0DAA0D;EAC5D;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;IACjC,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;EACtC","sourcesContent":[".radio-section {\n    margin-top: 20px  !important;\n    padding: 16px 24px  !important;\n    background-color: #e7e4e4ea  !important;\n    border-radius: 12px  !important;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08)  !important;\n  }\n  \n  .radio-label {\n    font-size: 18px  !important;\n    font-weight: 600  !important;\n    color: #333   !important;\n    margin-bottom: 12px  !important;\n  }\n  \n  .radio-group {\n    display: flex  !important;\n    flex-wrap: wrap  !important;\n    gap: 24px  !important;\n  }\n  \n  .radio-option {\n    margin-right: 16px  !important;\n  }\n  \n  .radio-option .MuiFormControlLabel-label {\n    font-size: 16px  !important;\n    color: #444  !important;\n  }\n  .button-container {\n    display: flex  !important;\n    gap: 12px  !important;\n    margin-top: 20px  !important;\n    justify-content: end  !important;\n  }\n  .add-alias-btn {\n    background-color: #fe602f  !important;\n    color: white  !important;\n    text-transform: none  !important;\n  }\n  \n  .add-alias-btn:hover {\n    background-color: #e25529  !important;\n  }\n  \n  /* Add Section button - outlined style */\n  .add-section-btn {\n    border: 1px solid #fe602f  !important;\n    color: #fe602f  !important;\n    text-transform: none  !important;\n  }\n  \n  .add-section-btn:hover {\n    background-color: #fff2ec  !important;\n    border-color: #e25529  !important;\n    color: #e25529  !important;\n  }\n\n\n  .dialog-box-container-modern {\n    padding: 32px !important;\n    background: linear-gradient(to bottom right, #ffffff, #f9f9f9) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1) !important;\n  }\n  \n  .dialog-title-modern {\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    color: #0070E9 !important;\n    padding: 24px 32px 0 !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    border-bottom: 1px solid #e0e0e0 !important;\n  }\n  \n  .dialog-close-icon {\n    color: #888 !important;\n    transition: transform 0.3s ease, color 0.3s ease !important;\n  }\n  .dialog-close-icon:hover {\n    color: #d32f2f !important;\n    transform: rotate(90deg) !important;\n  }\n  \n  .input-label-modern {\n    font-size: 15px !important;\n    font-weight: 600 !important;\n    margin: 20px 0 6px !important;\n    color: #3a3a3a !important;\n  }\n  \n  .text-field-modern {\n    width: 100% !important;\n    margin-bottom: 20px !important;\n    background-color: #f1f3f4 !important;\n    border-radius: 10px !important;\n    border: 1px solid #ccc !important;\n    transition: box-shadow 0.3s ease !important;\n  }\n  .text-field-modern:hover {\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1) !important;\n  }\n  \n  .add-btn-modern {\n    background-color: #FE602F !important;\n    color: #FFFFFF !important;\n    font-weight: 600 !important;\n    padding: 10px 26px !important;\n    border-radius: 12px !important;\n    text-transform: capitalize !important;\n    margin-top: 12px !important;\n    box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3) !important;\n  }\n  .add-btn-modern:hover {\n    background-color: #fc521e !important;\n  }\n  \n  .section-divider-modern {\n    margin: 40px 0 24px !important;\n    border: none !important;\n    border-top: 1px solid #ddd !important;\n  }\n  \n  .section-note-modern {\n    font-size: 14px !important;\n    color: #555 !important;\n    margin-bottom: 8px !important;\n    font-style: italic !important;\n  }\n  \n  .radio-label-modern {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    color: #333 !important;\n    margin-bottom: 12px !important;\n  }\n  \n  /* body {\n    font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif !important;\n  } */\n\n  .alias-edit-header {\n    background-color: #2d3e50 !important;\n    color: #ffffff !important;\n    font-weight: 600 !important;\n    font-size: 18px !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 16px 24px !important;\n  }\n  \n  .alias-edit-close {\n    color: #ffffff !important;\n    transition: transform 0.2s ease-in-out !important;\n  }\n  .alias-edit-close:hover {\n    transform: rotate(90deg) !important;\n  }\n  \n  .alias-edit-body {\n    background-color: #f4f6f8 !important;\n    padding: 32px 24px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 20px !important;\n    border-left: 5px solid #2d3e50 !important;\n  }\n  \n  .alias-edit-label {\n    font-size: 14px !important;\n    color: #333333 !important;\n    font-weight: 500 !important;\n  }\n  \n  .alias-edit-input {\n    background-color: #ffffff !important;\n    border-radius: 6px !important;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n  }\n  \n  .alias-edit-submit {\n    background-color: #2d3e50 !important;\n    color: #ffffff !important;\n    text-transform: none !important;\n    font-weight: 500 !important;\n    border-radius: 6px !important;\n    padding: 8px 20px !important;\n    align-self: flex-start !important;\n    transition: background-color 0.3s ease !important;\n  }\n  \n  .alias-edit-submit:hover {\n    background-color: #1c2938 !important;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
